const e = {
  name: "CheckmarkCircleFilled",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M26,14.6l-8,8l-4-4L12.6,20l5.4,5.4l9.4-9.4
	L26,14.6z"/>
</svg>
  `
};
export {
  e as CheckmarkCircleFilled
};
